import { useSidePanel } from 'features/side-panels/hooks/useSidePanel';
import { useQA } from 'features/qa/useQA';
import { useAppSelector } from 'store/hooks';
import { selectQAUnreadCount } from 'features/qa/qaSlice';

export const useQAControl = () => {
  const { isPanelVisible, togglePanel } = useSidePanel();

  const unreadCount = useAppSelector(selectQAUnreadCount);

  const { isFeatureAvailable } = useQA();

  const toggleQAPanel = () => {
    togglePanel('qa');
  };

  return {
    active: isPanelVisible('qa'),
    togglePanel: toggleQAPanel,
    icon: 'qa',
    isFeatureAvailable,
    unreadCount,
  };
};
